function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import Bugsnag from "@bugsnag/js";
import { productionDomains } from "../constants";
import { mask } from "./text";
import { getUrlParameter } from "./url";
var LEVELS = {
    debug: 0,
    error: 3,
    info: 1,
    silent: 4,
    warn: 2
};
var isValidLevel = function(level) {
    return typeof level === "string" && level in LEVELS;
};
var logLevel = function(param) {
    return isValidLevel(param) ? LEVELS[param] : LEVELS.silent;
}(getUrlParameter("log-level"));
var maskHeaders = function(headers, headersToMask) {
    var maskableHeaders = headersToMask.map(function(header) {
        return header.toLowerCase();
    });
    return Object.keys(headers).reduce(function(headers, name) {
        if (maskableHeaders.includes(name.toLowerCase())) {
            headers[name] = mask(headers[name]);
        }
        return headers;
    }, headers);
};
var getStorageEntries = function(storage, prefix) {
    var entries = [];
    for(var i = 0; i < storage.length; i++){
        var key = storage.key(i);
        if (key === null || key === void 0 ? void 0 : key.startsWith(prefix)) {
            var value = storage.getItem(key);
            entries.push([
                key.replace(prefix, ""),
                value
            ]);
        }
    }
    return entries;
};
var collectExtraInfo = function() {
    var extraInfo = {
        currentTimeStamp: Date.now()
    };
    var prefix = "vch.";
    var maskableParams = [
        "access_token",
        "refresh_token",
        "id_token"
    ];
    extraInfo["localStorage"] = getStorageEntries(localStorage, prefix).reduce(function(obj, param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        return _object_spread_props(_object_spread({}, obj), _define_property({}, key, key === "auth" ? maskHeaders(JSON.parse(value !== null && value !== void 0 ? value : "{}"), maskableParams) : value));
    }, {});
    extraInfo["sessionStorage"] = getStorageEntries(sessionStorage, prefix).reduce(function(obj, param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        return _object_spread_props(_object_spread({}, obj), _define_property({}, key, value));
    }, {});
    return extraInfo;
};
var report = function(message, error, extraInfo) {
    if (isIgnored(extraInfo)) {
        return;
    }
    if (hasBugsnagLogging() && Bugsnag.isStarted()) {
        Bugsnag.notify(error !== null && error !== void 0 ? error : _instanceof(message, Error) ? message : new Error(message), function(event) {
            var baseInfo = collectExtraInfo();
            var extra = _object_spread({}, baseInfo, extraInfo);
            if (extra) {
                event.addMetadata("extra", extra);
            }
        });
    }
};
var isIgnored = function(extraInfo) {
    if ((typeof extraInfo === "undefined" ? "undefined" : _type_of(extraInfo)) !== "object" || extraInfo === null) {
        return false;
    }
    var headers = extraInfo["headers"];
    if ((typeof headers === "undefined" ? "undefined" : _type_of(headers)) !== "object" || headers === null) {
        return false;
    }
    var castedHeaders = headers;
    var accountIdHeaderKey = Object.keys(castedHeaders).find(function(key) {
        return key.toLowerCase() === "x-neru-apiaccountid";
    });
    return Boolean(accountIdHeaderKey && castedHeaders[accountIdHeaderKey] === "nexmo-dashboards");
};
export var reportRequest = function(error, requestInfo) {
    var _requestInfo_headers;
    report("Request failed.", error, _object_spread_props(_object_spread({}, requestInfo), {
        headers: maskHeaders(_object_spread({}, (_requestInfo_headers = requestInfo.headers) !== null && _requestInfo_headers !== void 0 ? _requestInfo_headers : {}), [
            "X-Hasura-Admin-Secret",
            "Authorization"
        ])
    }));
};
export var getLogger = function(name) {
    var log = function(level, color) {
        return function(message, error, extraInfo) {
            console["log"]("%c".concat(level.toUpperCase(), "%c: ").concat(name, ": ").concat(message), "color: ".concat(color), "color: black");
            if (level === "error") {
                report(message, error, extraInfo);
            }
        };
    };
    return {
        debug: logLevel <= LEVELS.debug ? log("debug", "gray") : function() {},
        error: logLevel <= LEVELS.error ? log("error", "red") : report,
        info: logLevel <= LEVELS.info ? log("info", "blue") : function() {},
        warn: logLevel <= LEVELS.warn ? log("warn", "orange") : function() {}
    };
};
export var hasBugsnagLogging = function() {
    return productionDomains.some(function(domain) {
        return window.location.hostname.endsWith(domain);
    }) && !window.location.hostname.includes("qa.");
};

//# sourceMappingURL=logger.js.map